import React, { useEffect, useState } from 'react';
import { makeStyles } from 'tss-react/mui';
import { Box, Grid } from '@mui/material';
import {
  Breadcrumbs,
  PageTitleAndSubTitle,
  // Table,
  CardComponent,
  DashedStandardDropdown,
  BasicTable,
  Columns,
  NoDataVisual,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import properties from '../../core-utils/properties';
import planPerformanceMetricsMessages from '../../core-utils/helper-utils/planPerformanceMetricsMessages';
import axios from 'axios';
import Loader from '../../_components/molecules/Loader';
import { COMMON_TEXTS } from '../../core-utils/messages/CommonConstants';
import { useStores } from '../../stores';
import {
  numberToCurrencyFormatter,
  formatNetworkType,
  formatProivderType,
} from '../../core-utils/helper-utils/helper';
import ReportsModal from '../../_components/organisms/ReportsModal';
import TabSelection from '../../_components/molecules/TabSelection';
import RecommendationsTab from '../../_components/organisms/RecommendationsTab';
import { getRecommendationsData } from '../../core-utils/helper-utils/recommendationsTabHelper';
import { ClaimsTrendData, claimTrendAPICall, getMonthYear } from './helper';
import { dropDownMenuItemsValues } from '../../core-utils/helper-utils/tableSortHelper';
import {
  collapsiblePatientTableHeaderStyles,
  formatMemberClaim,
} from '../../core-utils/helper-utils/riskPatientDetailsHelper';
import MedicalHistoryDetails from '../../_components/organisms/MedicalHistoryDetails';
import { CircularLoader } from '@HomaHealth/ui-component-library';
import { PATIENT_DETAILS, REJECTED_CLAIMS } from '../../core-utils/routes';
import { useNavigate } from 'react-router-dom';
import { useAPIPayload } from '../../core-utils/helper-utils/apiPayloadHelper';
import usePlanDates from '../../core-utils/custom-hooks/PlanDates';
import DateFilter from '../../_components/molecules/DateFilter';
import { observer } from 'mobx-react';
import { downloadPdf } from '../../core-utils/helper-utils/downloadPdfHelper';
import Snackbar from '../../_components/atoms/Snackbar';
import { AlertColor as MuiColor } from '@mui/material/Alert';
import componentConstants from '../../core-utils/messages/componentConstants';

export const getTruncatedText = (label: string, width: string) => {
  const useStyles = makeStyles()({
    ellipses: {
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      width: width,
      whiteSpace: 'nowrap',
      '&:hover': {
        overflow: 'visible',
        whiteSpace: 'normal',
        height: 'auto',
      },
    },
  });

  const { classes } = useStyles();
  return (
    <Typography
      fontSize="14px"
      fontType="regular"
      lineHeight="24px"
      textColor={patientAccessTheme.palette.text.mediumemphasis}
      className={classes.ellipses}
    >
      {label}
    </Typography>
  );
};
const RejectedClaimStatusPage = observer(() => {
  const useStyles = makeStyles()({
    mainDiv: {
      backgroundColor: '',
      border: '',
      marginTop: '40px',
      marginLeft: '63px',
    },
    flexContainer: {
      display: 'flex',
      flexDirection: 'row',
      marginTop: '36px',
      marginBottom: '28px',
    },
    OverViewCardMargin: {
      marginRight: '24px',
    },
    GridItem: {
      marginBottom: '27px',
      display: 'inline-block',
    },
    box: {
      display: 'flex',
      flexDirection: 'row',
      boxSizing: 'border-box',
      background: 'white',
      border: '1px solid grey}',

      width: '1176px',
      height: '388px',
    },

    tableHeader: {
      height: '40px',
      backgroundColor: patientAccessTheme.palette.grey[100],
      borderTop: `1px solid ${patientAccessTheme.palette.grey[300]}`,
      borderBottom: `1px solid ${patientAccessTheme.palette.grey[300]}`,
      '&:first-child': {
        paddingLeft: '38px',
      },
      paddingTop: '20px',
      textAlign: 'left',
      whiteSpace: 'nowrap',
    },
    tableRow: {
      height: '56px',
      padding: '0px',
      paddingTop: '20px',
      borderBottom: `1px solid ${patientAccessTheme.palette.grey[300]}`,
      '& td:first-child': {
        paddingLeft: '38px',
      },
      whiteSpace: 'nowrap',
    },
    headerText: {
      fontSize: '12px',
      fontHeight: '12px',
      fontWeight: 500,
      color: patientAccessTheme.palette.text.highemphasis,
      textAlign: 'left',
    },
    pagination: {
      position: 'absolute',
      right: '24px',
      bottom: '20px',
    },
    flex: {
      display: 'flex',
    },
    emptyData: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      padding: '20px',
    },
  });
  const { classes } = useStyles();
  const pageSize = 10;

  const [
    loadingClaimStatusRejected,
    setLoadingClaimStatusRejected,
  ] = useState<boolean>(false);
  const [clickedMember, handleOnclickedMember] = useState<string>();
  const [openReportsModal, setOpenReportsModal] = useState(false);
  const snackBarMessages = componentConstants.ORGANISMS.REPORTS_MODAL;

  const navigate = useNavigate();
  const pathStore = useStores().pathStore;
  const memberSummaryStore = useStores().memberSummaryStore;

  const [selectedTabIndex, setSelectedTabIndex] = useState<number>(0);

  const [
    rejectedClaimsDropdownValue,
    setRejectedClaimsDropdownValue,
  ] = useState<string>('Members');

  const [rejectedClaimsMembersData, setRejectedClaimsMembersData] = useState<
    any[]
  >([]);
  const [
    rejectedClaimsProvidersData,
    setRejectedClaimsProvidersData,
  ] = useState<any[]>([]);
  const [rejectedClaimsCount, setRejectedClaimsCount] = useState<number>(0);
  const [rejectedClaimsLoader, setRejectedClaimsLoader] = useState<boolean>(
    false,
  );
  const quarterlyReportStore = useStores().quaterlyReportStore;
  const {
    incurredStartDate,
    incurredEndDate,
    paidStartDate,
    paidEndDate,
    isIncurredDate,
    isPaidDate,
    isPlanDatesFetched,
    aggregationParameter,
  } = quarterlyReportStore;

  const { getPlanDates, loading: isPlanDatesLoading } = usePlanDates();
  const payload = useAPIPayload();
  const abortController = new AbortController();

  //snackbar
  const handleOpenSnackBar = (
    message: string,
    severity: MuiColor,
    duration: number | null,
  ) => {
    setSnackbarState({
      open: true,
      message: message,
      severity: severity,
      duration: duration,
    });
  };

  const handleCloseSnackBar = (
    event?: React.SyntheticEvent,
    reason?: string,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarState({
      open: false,
      message: '',
      severity: undefined,
      duration: null,
    });
  };

  const [snackbarState, setSnackbarState] = React.useState<{
    open: boolean;
    message: string;
    severity: MuiColor | undefined;
    duration: null | number;
  }>({
    open: false,
    message: '',
    severity: undefined,
    duration: null,
  });

  const getRejectedClaimsMemberData = async () => {
    const rejectedClaims: any[] = [];
    const wasteCategoryMemberAndClaimIds: any[] = [];
    const baseUrl = properties.aiqBaseUrl + properties.getClaimsStatusRejected;

    const requestBody = {
      ...payload,
      pageNumber: pageIndex - 1,
      pageSize: pageSize,
      sortField: sortField,
      sortOrder: sortOrder,
      rejectedClaimsType: rejectedClaimsDropdownValue,
      aggregationParameter: 'incurred',
    };
    setRejectedClaimsLoader(true);
    await axios
      .post(baseUrl, requestBody, { signal: abortController.signal })
      .then(async (res) => {
        if (res) {
          const response = res?.data?.data?.claims;

          const promises = response?.rejectedClaimsList?.map(
            async (rejectedClaim: any) => {
              const eachCategory: any = {
                member_unique_id: rejectedClaim?.member_unique_id,
                totalClaims: rejectedClaim?.totalClaims,
                totalCost: rejectedClaim?.totalCost,
              };
              const memberAndClaimId = [];
              memberAndClaimId.push(rejectedClaim?.member_unique_id);
              memberAndClaimId.push(rejectedClaim?.claimIds);
              rejectedClaims.push(eachCategory);

              wasteCategoryMemberAndClaimIds.push(memberAndClaimId);
              return axios.post(
                properties.aiqBaseUrl +
                  properties.membersBaseUrl +
                  properties.memberDetails,
                {
                  eg_nid: employerGroupStore.employerGroupResponseData.eg_nid,
                  paidStartDate,
                  paidEndDate,
                  incurredStartDate,
                  incurredEndDate,
                  aggregationParameter,
                  member_unique_id: [rejectedClaim?.member_unique_id],
                  limit: 20,
                  increment: 0,
                  claim_id_list: rejectedClaim?.claimIds,
                  claim_status: 'Rejected',
                },
              );
            },
          );

          const responses = await Promise.all(promises);

          responses.forEach((response, index) => {
            rejectedClaims[index]['MedicalHistoryDetails'] = (
              <MedicalHistoryDetails
                riskPatientDetails={formatMemberClaim(
                  response?.data?.data?.slice().reverse(),
                  response.config.data.member_unique_id,
                )}
              />
            );
          });
          setRejectedClaimsCount(response?.totalCount);
          setRejectedClaimsMembersData(rejectedClaims);
          setRejectedClaimsLoader(false);
        }
      })
      .catch(() => {
        setRejectedClaimsLoader(false);
      });
  };

  const getRejectedClaimsProvidersData = async () => {
    const rejectedClaims: any[] = [];
    const wasteCategoryMemberAndClaimIds: any[] = [];
    const baseUrl = properties.aiqBaseUrl + properties.getClaimsStatusRejected;
    const requestBody = {
      ...payload,
      pageNumber: pageIndex - 1,
      pageSize: pageSize,
      sortField: sortField,
      sortOrder: sortOrder,
      rejectedClaimsType: rejectedClaimsDropdownValue,
    };
    setRejectedClaimsLoader(true);
    await axios
      .post(baseUrl, requestBody, { signal: abortController.signal })
      .then(async (res) => {
        if (res) {
          const response = res?.data?.data?.claims;

          const promises = response?.rejectedClaimsList?.map(
            async (rejectedClaim: any) => {
              const eachCategory: any = {
                providerName: rejectedClaim?.providerName,
                providerType: formatProivderType(rejectedClaim?.providerType),
                networkType: formatNetworkType(rejectedClaim?.networkType),
                totalClaims: rejectedClaim?.totalClaims,
                totalCost: rejectedClaim?.totalCost,
              };
              const memberAndClaimId = [];
              memberAndClaimId.push(rejectedClaim?.memberIds);
              memberAndClaimId.push(rejectedClaim?.claimIds);
              rejectedClaims.push(eachCategory);
              wasteCategoryMemberAndClaimIds.push(memberAndClaimId);

              return axios.post(
                properties.aiqBaseUrl +
                  properties.membersBaseUrl +
                  properties.memberDetails,
                {
                  eg_nid: employerGroupStore.employerGroupResponseData.eg_nid,
                  startDate:
                    aggregationParameter === 'paid'
                      ? paidStartDate
                      : incurredStartDate,
                  endDate:
                    aggregationParameter === 'paid'
                      ? paidEndDate
                      : incurredEndDate,
                  member_unique_id: rejectedClaim.memberIds,
                  limit: 20,
                  increment: 0,
                  claim_id_list: rejectedClaim.claimIds,
                  claim_status: 'Rejected',
                },
              );
            },
          );

          const responses = await Promise.all(promises);

          responses.forEach((response, index) => {
            rejectedClaims[index]['MedicalHistoryDetails'] = (
              <MedicalHistoryDetails
                riskPatientDetails={formatMemberClaim(
                  response?.data?.data?.slice().reverse(),
                  response.config.data.member_unique_id,
                )}
              />
            );
          });
          setRejectedClaimsCount(response?.totalCount);
          setRejectedClaimsProvidersData(rejectedClaims);
          setRejectedClaimsLoader(false);
        }
      })
      .catch(() => {
        setRejectedClaimsLoader(false);
      });
  };

  const handleTablePageChange = (
    event: React.ChangeEvent<unknown>,
    value: number,
    setPageNumber: any,
  ) => {
    setPageNumber(value);
  };
  const recommendedTabStore = useStores().recommendedTabStore;

  const apiCalls = async () => {
    setLoadingClaimStatusRejected(true);
    isPlanDatesFetched &&
      (await Promise.all([
        claimTrendAPICall(
          {
            ...payload,
            aggregationParameter: 'incurred',
          },
          setClaimsTrendData,
          setIsDataEmptyForClaimsPercent,
          setIsDataEmptyWithHurrayMessageForClaimsPercent,
          abortController.signal,
        ),
      ]).then(() => {
        setLoadingClaimStatusRejected(false);
      }));

    setLoadingClaimStatusRejected(false);
  };

  // Edit duration related states and functions

  const employerGroupStore = useStores().employerGroupStore;
  const [pageIndex, setPageIndex] = useState(1);
  const [claimsTrendData, setClaimsTrendData] = useState<ClaimsTrendData[]>();

  const [recommendationLoading, setRecommendationLoading] = useState<boolean>(
    false,
  );
  const [recommendationFetched, setRecommendationFetched] = useState<boolean>(
    false,
  );
  const handleSelectedIndex = (index: number) => {
    setSelectedTabIndex(index);
    if (!recommendationFetched) {
      getRecommendationsData(
        employerGroupStore?.employerGroupResponseData?.eg_nid,
        planPerformanceMetricsMessages.pageTitlesofRejectedClaimStatus
          .titleAndSubtitle.title,
        recommendedTabStore,
        setRecommendationLoading,
      );
      setRecommendationFetched(true);
    }
  };

  const [
    isDataEmptyForClaimsPercent,
    setIsDataEmptyForClaimsPercent,
  ] = useState(false);
  const [
    isDataEmptyWithHurrayMessageForClaimsPercent,
    setIsDataEmptyWithHurrayMessageForClaimsPercent,
  ] = useState(false);

  const sortField =
    planPerformanceMetricsMessages.pageTitlesofRejectedClaimStatus
      .REJECTED_CLAIMS_PERCENT_TABLE.SORTFIELD;
  const sortOrder =
    planPerformanceMetricsMessages.pageTitlesofRejectedClaimStatus
      .REJECTED_CLAIMS_PERCENT_TABLE.SORTORDER;

  // useEffects

  useEffect(() => {
    isPlanDatesFetched && rejectedClaimsDropdownValue === 'Members'
      ? getRejectedClaimsMemberData()
      : getRejectedClaimsProvidersData();
  }, [
    pageIndex,
    rejectedClaimsDropdownValue,
    isPlanDatesFetched,
    isIncurredDate,
    isPaidDate,
    incurredStartDate,
    incurredEndDate,
    paidStartDate,
    paidEndDate,
    aggregationParameter,
  ]);

  useEffect(() => {
    apiCalls();
    return () => {
      abortController.abort();
    };
  }, [
    isPlanDatesFetched,
    isIncurredDate,
    isPaidDate,
    incurredStartDate,
    incurredEndDate,
    paidStartDate,
    paidEndDate,
    aggregationParameter,
  ]);

  useEffect(() => {
    if (clickedMember) {
      memberSummaryStore.setPathDetails([
        [
          planPerformanceMetricsMessages.breadCrumb.text,
          planPerformanceMetricsMessages.breadCrumb.summary,
          {
            color: patientAccessTheme.palette.primary[500],
            fontWeight: 500,
          },
          () => {
            navigate(REJECTED_CLAIMS);
          },
        ],
      ]);

      navigate(PATIENT_DETAILS, { state: { memberId: clickedMember } });
    }
  }, [clickedMember]);

  useEffect(() => {
    const fetchPlanDates = async () => {
      if (!isPlanDatesFetched) {
        await getPlanDates();
      }
    };
    if (!employerGroupStore?.employerGroupResponseData?.eg_nid[0]) {
      return;
    }
    fetchPlanDates();
  }, [employerGroupStore?.employerGroupResponseData?.eg_nid]);

  const rejectedClaimsTrendColumns: Columns[] = [
    {
      name: 'Month - Year',
      cellStyles: collapsiblePatientTableHeaderStyles,
      typographyStyles: collapsiblePatientTableHeaderStyles,
      width: '380px',
      cellPadding: '8px 16px 8px 20px',
      align: 'left',
    },
    {
      name: 'Rejected Claims',
      cellStyles: collapsiblePatientTableHeaderStyles,
      typographyStyles: collapsiblePatientTableHeaderStyles,
      width: '380px',
      cellPadding: '8px 16px 8px 20px',
      align: 'right',
      showThisColumn: true,
      sortColumnName: 'totalRejectedClaims',
      DropDownMenuItems: dropDownMenuItemsValues,
    },
    {
      name: 'Percentage of Rejected Claims',
      cellStyles: collapsiblePatientTableHeaderStyles,
      typographyStyles: collapsiblePatientTableHeaderStyles,
      width: '380px',
      cellPadding: '8px 16px 8px 20px',
      align: 'right',
      showThisColumn: true,
      sortColumnName: 'rejectedClaimsPercent',
      DropDownMenuItems: dropDownMenuItemsValues,
    },
    {
      name: 'Billed Amount of Rejected Claims',
      cellStyles: collapsiblePatientTableHeaderStyles,
      typographyStyles: collapsiblePatientTableHeaderStyles,
      width: '380px',
      cellPadding: '8px 16px 8px 20px',
      align: 'right',
      showThisColumn: true,
      sortColumnName: 'totalBilledAmount',
      DropDownMenuItems: dropDownMenuItemsValues,
    },
  ];
  // const rejectedClaimsTrendColumns = [
  //   {
  //     Header: (
  //       <Typography className={classes.headerText} style={{ width: '195px' }}>
  //         {'Month - Year'}
  //       </Typography>
  //     ),
  //     Footer: 'Month - Year',
  //     accessor: 'monthYear',
  //   },
  //   {
  //     Header: 'Rejected Claims',
  //     Footer: 'Rejected Claims',
  //     accessor: 'totalRejectedClaims',
  //     id: 'totalRejectedClaims',
  //     showThisColumn: true,
  //     DropDownMenuItems: dropDownMenuItemsValues,
  //     Cell: ({ value }: any) => (
  //       <div style={{ textAlign: 'right', width: '94px' }}>{value}</div>
  //     ),
  //   },
  //   {
  //     Header: 'Percentage of Rejected Claims',
  //     Footer: 'Percentage of Rejected Claims',
  //     accessor: 'rejectedClaimsPercent',
  //     id: 'rejectedClaimsPercent',
  //     showThisColumn: true,
  //     DropDownMenuItems: dropDownMenuItemsValues,
  //     Cell: ({ value }: any) => (
  //       <div style={{ textAlign: 'right', width: '180px' }}>{value}</div>
  //     ),
  //   },
  //   {
  //     Header: 'Billed Amount of Rejected Claims',
  //     Footer: 'Billed Amount of Rejected Claims',
  //     id: 'totalBilledAmount',
  //     showThisColumn: true,
  //     DropDownMenuItems: dropDownMenuItemsValues,
  //     accessor: 'totalBilledAmount',
  //     Cell: ({ value }: any) => (
  //       <div style={{ textAlign: 'right', width: '195px' }}>{value}</div>
  //     ),
  //   },
  // ];

  //Columns
  const rejectedClaimsMemberColumns: Columns[] = [
    {
      name: 'Member ID',
      cellStyles: collapsiblePatientTableHeaderStyles,
      typographyStyles: collapsiblePatientTableHeaderStyles,
      width: '380px',
      cellPadding: '8px 36px 8px 48px',
      align: 'left',
    },
    {
      name: 'No. of Claims',
      cellStyles: collapsiblePatientTableHeaderStyles,
      typographyStyles: collapsiblePatientTableHeaderStyles,
      width: '380px',
      cellPadding: '8px 36px 8px 56px',
      align: 'right',
      showThisColumn: true,
      sortColumnName: 'totalClaims',
      DropDownMenuItems: dropDownMenuItemsValues,
    },
    {
      name: 'Total Billed Amount',
      cellStyles: collapsiblePatientTableHeaderStyles,
      typographyStyles: collapsiblePatientTableHeaderStyles,
      width: '380px',
      cellPadding: '8px 36px 8px 56px',
      align: 'right',
      showThisColumn: true,
      sortColumnName: 'totalCost',
      DropDownMenuItems: dropDownMenuItemsValues,
    },
  ];
  const rejectedClaimsProvidersColumns: Columns[] = [
    {
      name: 'Proivder',
      cellStyles: collapsiblePatientTableHeaderStyles,
      typographyStyles: collapsiblePatientTableHeaderStyles,
      width: '380px',
      cellPadding: '8px 36px 8px 56px',
      align: 'left',
    },
    {
      name: 'Type',
      cellStyles: collapsiblePatientTableHeaderStyles,
      typographyStyles: collapsiblePatientTableHeaderStyles,
      width: '250px',
      cellPadding: '8px 36px 8px 56px',
      align: 'left',
    },
    {
      name: 'In/Out Network',
      cellStyles: collapsiblePatientTableHeaderStyles,
      typographyStyles: collapsiblePatientTableHeaderStyles,
      width: '250px',
      cellPadding: '8px 36px 8px 56px',
      align: 'left',
    },
    {
      name: 'Claims',
      cellStyles: collapsiblePatientTableHeaderStyles,
      typographyStyles: collapsiblePatientTableHeaderStyles,
      width: '150px',
      cellPadding: '8px 36px 8px 56px',
      align: 'right',
      sortColumnName: 'totalClaims',
      showThisColumn: true,
      DropDownMenuItems: dropDownMenuItemsValues,
    },
    {
      name: 'Total Billed Amount',
      cellStyles: collapsiblePatientTableHeaderStyles,
      typographyStyles: collapsiblePatientTableHeaderStyles,
      width: '300px',
      cellPadding: '8px 36px 8px 56px',
      align: 'right',
      sortColumnName: 'totalCost',
      showThisColumn: true,
      DropDownMenuItems: dropDownMenuItemsValues,
    },
  ];

  const getDataForRejectedClaimsTrendsTable = () => {
    const claimTrendsTableData: any[] = [];
    claimsTrendData?.forEach((item) => {
      const tempRowData: any = [];
      tempRowData.push(getMonthYear(item.month, item.year));
      tempRowData.push(String(item.totalRejectedClaims));
      tempRowData.push((item.rejectedClaimsPercent?.toFixed(2) ?? 0) + '%');
      tempRowData.push(numberToCurrencyFormatter(item.totalBilledAmount, true));

      claimTrendsTableData.push(tempRowData);
    });
    return claimTrendsTableData;
  };

  const getDataForRejectedClaimsMembersTable = () => {
    const rejectedClaimsMembers: any[] = [];
    rejectedClaimsMembersData.map((claim) => {
      const eachCategory: any = [];

      eachCategory.push(claim?.member_unique_id);
      eachCategory.push(claim?.totalClaims);
      eachCategory.push(numberToCurrencyFormatter(claim?.totalCost));
      eachCategory.push(claim.MedicalHistoryDetails);

      rejectedClaimsMembers.push(eachCategory);
    });
    return rejectedClaimsMembers;
  };
  const getDataForRejectedClaimsProvidersTable = () => {
    const rejectedClaimsProviders: any[] = [];

    rejectedClaimsProvidersData.map((claim) => {
      const eachCategory: any = [];
      eachCategory.push(claim?.providerName);
      eachCategory.push(claim?.providerType);
      eachCategory.push(claim?.networkType);
      eachCategory.push(claim?.totalClaims);
      eachCategory.push(numberToCurrencyFormatter(claim?.totalCost));
      eachCategory.push(claim.MedicalHistoryDetails);

      rejectedClaimsProviders.push(eachCategory);
    });
    return rejectedClaimsProviders;
  };
  const RejectedClaimStatusTable = () => {
    const [columnId, setColumnId] = useState<string>();
    const [
      rejectedClaimsColumnId,
      setRejectedClaimsColumnId,
    ] = useState<string>('');

    // const [
    //   showSortingAndFiltering,
    //   setShowSortingAndFiltering,
    // ] = useState<boolean>(true);

    const [loader] = useState<any>(<Loader />);

    const handleHeaderMouseEnter = (column: any, setColumnId?: any) => {
      setColumnId(column?.id || column?.sortColumnName);
    };

    const handleHeaderMouseLeave = (setColumnId?: any) => {
      setColumnId('');
    };

    const handleRejectTrendSort = (event: any, column: any, item: any) => {
      const sortOrder = item.actionType === 'ascendingSorting' ? 1 : -1;
      const sortColumnName = column.id;
      if (!sortColumnName) {
        return;
      }

      const newList = claimsTrendData
        ? [...claimsTrendData].sort((a: any, b: any) => {
            if (a[sortColumnName] < b[sortColumnName]) {
              return -1 * sortOrder;
            } else if (a[sortColumnName] > b[sortColumnName]) {
              return 1 * sortOrder;
            }
            return 0;
          })
        : [];

      setClaimsTrendData(newList);
    };

    const handleSort: any = (event: any, column: any, item: any) => {
      const sortOrder = item.actionType === 'ascendingSorting' ? 1 : -1;
      const sortColumnName = column.sortColumnName;
      if (!sortColumnName) {
        return;
      }

      const tableData =
        rejectedClaimsDropdownValue === 'Members'
          ? rejectedClaimsMembersData
          : rejectedClaimsProvidersData;

      const newList = tableData
        ? [...tableData].sort((a: any, b: any) => {
            if (a[sortColumnName] < b[sortColumnName]) {
              return -1 * sortOrder;
            } else if (a[sortColumnName] > b[sortColumnName]) {
              return 1 * sortOrder;
            }
            return 0;
          })
        : [];

      rejectedClaimsDropdownValue === 'Members'
        ? setRejectedClaimsMembersData(newList)
        : setRejectedClaimsProvidersData(newList);
    };

    return (
      <div>
        {isPlanDatesLoading || loadingClaimStatusRejected ? (
          loader
        ) : (
          <>
            <Box
              sx={{
                marginLeft: '-1px',
                marginTop: '22px',
                width: '1100px',
              }}
            >
              <CardComponent
                title={
                  planPerformanceMetricsMessages.pageTitlesofRejectedClaimStatus
                    .REJECTED_CLAIMS_PERCENT_TABLE.TITLE
                }
                subTitle={
                  planPerformanceMetricsMessages.pageTitlesofRejectedClaimStatus
                    .REJECTED_CLAIMS_PERCENT_TABLE.SUBTITLE
                }
                body={
                  isDataEmptyForClaimsPercent ||
                  isDataEmptyWithHurrayMessageForClaimsPercent ? (
                    <Grid className={classes.emptyData}>
                      <NoDataVisual
                        content={'No Data Available'}
                        height="200px"
                      />
                    </Grid>
                  ) : (
                    <BasicTable
                      displayType="row"
                      columns={rejectedClaimsTrendColumns}
                      rowsData={getDataForRejectedClaimsTrendsTable()}
                      width="1100px"
                      headerCellHeight="48px"
                      showPagination={false}
                      cellPadding="8px 16px 8px 20px"
                      showOnHoverHeader={true}
                      // pageNumber={pageIndex}
                      // pageCount={rejectedClaimsCount}
                      columnId={columnId}
                      // handlePagination={(event, value) => {
                      //   handleTablePageChange(event, value, setPageIndex);
                      // }}
                      handleHeaderMouseEnter={(column: any) =>
                        handleHeaderMouseEnter(column, setColumnId)
                      }
                      handleHeaderMouseLeave={() =>
                        handleHeaderMouseLeave(setColumnId)
                      }
                      handleMenuItem={handleRejectTrendSort}
                    />
                  )
                  // <Table
                  //   classNameForTableDataRow={classes.tableRow}
                  //   classNameForTableHeader={classes.tableHeader}
                  //   columns={rejectedClaimsTrendColumns}
                  //   data={getDataForRejectedClaimsTrendsTable()}
                  //   isDataEmpty={isDataEmptyForClaimsPercent}
                  //   isDataEmptySendHurrayMessage={
                  //     isDataEmptyWithHurrayMessageForClaimsPercent
                  //   }
                  //   onHoverRowData={() => {}}
                  //   controlledPageIndex={pageIndex}
                  //   isManualPagination={true}
                  //   showPagination={false}
                  //   widthOfTable="1100px"
                  //   headerBgColor='#E5E9F0'
                  //   columnId={columnId}
                  //   handleMouseEnterHeader={(column: any) =>
                  //     handleHeaderMouseEnter(column, setColumnId)
                  //   }
                  //   handleMouseLeaveHeader={() =>
                  //     handleHeaderMouseLeave(setColumnId)
                  //   }
                  //   showSortingAndFiltering={showSortingAndFiltering}
                  //   setShowSortingAndFiltering={setShowSortingAndFiltering}
                  //   showOnHoverHeader={true}
                  //   handleMenuItem={handleRejectTrendSort}
                  // />
                }
                width="1176px"
              />
            </Box>

            <Box
              sx={{
                marginLeft: '-1px',
                marginTop: '22px',
                width: '1100px',
                marginBottom: '22px',
              }}
            >
              <CardComponent
                title={
                  planPerformanceMetricsMessages.pageTitlesofRejectedClaimStatus
                    .REJECTED_CLAIMS_TABLE.TITLE
                }
                subTitle={
                  planPerformanceMetricsMessages.pageTitlesofRejectedClaimStatus
                    .REJECTED_CLAIMS_TABLE.SUBTITLE
                }
                dropdownElement={
                  <DashedStandardDropdown
                    options={
                      planPerformanceMetricsMessages.rejectedClaimsDropdownValues
                    }
                    displayValue={
                      planPerformanceMetricsMessages.rejectedClaimsDropdownValues
                    }
                    value={rejectedClaimsDropdownValue}
                    handleChange={(event: any) => {
                      const value: string = event.target.value as string;
                      setRejectedClaimsDropdownValue(value);
                      setPageIndex(1);
                    }}
                  />
                }
                body={
                  rejectedClaimsLoader ? (
                    <Box
                      style={{
                        display: 'flex',
                        height: '450px',
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}
                    >
                      <CircularLoader />
                    </Box>
                  ) : (
                    <>
                      <Grid>
                        {rejectedClaimsDropdownValue === 'Members' ? (
                          <BasicTable
                            displayType="row"
                            columns={rejectedClaimsMemberColumns}
                            rowsData={getDataForRejectedClaimsMembersTable()}
                            getMemberId={(value: string) => {
                              handleOnclickedMember(value);
                            }}
                            isCollapsiblePatientTable={true}
                            width="1100px"
                            headerCellHeight="48px"
                            showPagination
                            cellPadding="8px 16px 8px 20px"
                            showOnHoverHeader={true}
                            pageNumber={pageIndex}
                            pageCount={rejectedClaimsCount}
                            columnId={rejectedClaimsColumnId}
                            handlePagination={(event, value) => {
                              handleTablePageChange(event, value, setPageIndex);
                            }}
                            handleHeaderMouseEnter={(column: any) =>
                              handleHeaderMouseEnter(
                                column,
                                setRejectedClaimsColumnId,
                              )
                            }
                            handleHeaderMouseLeave={() =>
                              handleHeaderMouseLeave(setRejectedClaimsColumnId)
                            }
                            handleMenuItem={handleSort}
                          />
                        ) : (
                          <BasicTable
                            displayType="row"
                            columns={rejectedClaimsProvidersColumns}
                            rowsData={getDataForRejectedClaimsProvidersTable()}
                            getMemberId={(value: string) => {
                              handleOnclickedMember(value);
                            }}
                            isCollapsiblePatientTable={true}
                            width="1100px"
                            headerCellHeight="48px"
                            showPagination
                            cellPadding="8px 16px 8px 20px"
                            showOnHoverHeader={true}
                            pageNumber={pageIndex}
                            pageCount={rejectedClaimsCount}
                            columnId={rejectedClaimsColumnId}
                            handlePagination={(event, value) => {
                              handleTablePageChange(event, value, setPageIndex);
                            }}
                            handleHeaderMouseEnter={(column: any) =>
                              handleHeaderMouseEnter(
                                column,
                                setRejectedClaimsColumnId,
                              )
                            }
                            handleHeaderMouseLeave={() =>
                              handleHeaderMouseLeave(setRejectedClaimsColumnId)
                            }
                            handleMenuItem={handleSort}
                          />
                        )}
                      </Grid>
                    </>
                  )
                }
                width="1176px"
              />
            </Box>
          </>
        )}
      </div>
    );
  };
  const getPath = () => {
    if (pathStore.path.length !== 0) {
      return pathStore.path;
    } else {
      return [];
    }
  };

  return (
    <div className={classes.mainDiv}>
      {getPath().length !== 0 && (
        <Box style={{ marginBottom: '20px' }}>
          <Breadcrumbs itemList={getPath()} />
        </Box>
      )}
      <Box style={{ width: '1182px', position: 'relative' }}>
        <PageTitleAndSubTitle
          title={
            planPerformanceMetricsMessages.pageTitlesofRejectedClaimStatus
              .titleAndSubtitle.title
          }
          subTitle={
            planPerformanceMetricsMessages.pageTitlesofRejectedClaimStatus
              .titleAndSubtitle.subTitle
          }
          showDownloadButton={true}
          // downloadButtonAction={() => setOpenReportsModal(true)}
          downloadButtonAction={() => {
            downloadPdf(
              'rejectedClaimsReport',
              {
                employer:
                  employerGroupStore?.employerGroupResponseData
                    ?.employer_group_name,
                member_unique_id_list: [],
                claim_id_list: [],
                maxClaimDate:
                  employerGroupStore?.employerGroupResponseData?.max_claim_date,
                ...payload,
              },
              handleOpenSnackBar,
              'open',
            );
            handleOpenSnackBar(
              snackBarMessages.SNACKBAR_MESSAGES.OPEN_REPORT,
              'info',
              6000,
            );
          }}

          // showQueryDataButton={checkUserAccess(
          //   UserAccessConstants.COHORT_DETAILS,
          //   loginPageStore.userResponse.role.name,
          //   loginPageStore.userFeatures,
          // )}
        />
        <div
          style={{
            position: 'absolute',
            top: '-2px',
            left: '140px',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <Typography
            fontSize="17px"
            lineHeight="21px"
            textColor={patientAccessTheme.palette.text.mediumemphasis}
            fontType="semiBold"
            margin="0px 8px"
          >
            {COMMON_TEXTS.FOR}
          </Typography>
          <DateFilter disablePaidDate={true} />
        </div>
        <TabSelection
          selectedTabIndex={selectedTabIndex}
          setSelectedTabIndex={handleSelectedIndex}
          recommendationFetched={recommendationFetched}
        />
      </Box>
      <Box
        sx={{
          marginTop: '23px',
        }}
      >
        {selectedTabIndex === 0 && <RejectedClaimStatusTable />}
        {selectedTabIndex === 1 && (
          <RecommendationsTab
            recommendationLoading={recommendationLoading}
            isInternalPage={true}
          />
        )}
      </Box>
      <Snackbar
        {...snackbarState}
        handleClose={handleCloseSnackBar}
        vertical="bottom"
        horizontal="right"
      />
      <ReportsModal
        open={openReportsModal}
        setOpen={setOpenReportsModal}
        startDate={
          aggregationParameter === 'paid' ? paidStartDate : incurredStartDate
        }
        endDate={
          aggregationParameter === 'paid' ? paidEndDate : incurredEndDate
        }
      />
    </div>
  );
});

export default RejectedClaimStatusPage;
